import { Route, Routes } from "react-router-dom";
import RootLayout from "./Components/Layout/RootLayout";
import { AdminLogin, Home,UserSubCategoryPage,TbkProductPage,TbkProductDetailPage } from "./Components/pages/ImportPages";
import AppAdminLayout from "./Components/Layout/AppAdminLayout";
import AdminContent from "./Components/pages/AdminContent";
import GlobalToast from "./Components/loader/GlobalToast";
import UserSubCategoryPageLoad from "./Components/User/SubCategory/UserSubCategoryPageLoad";
import TbkProductPageScrollLoad from "./Components/User/Products/TbkProductPageScrollLoad";
import ContactUs from "./Components/User/ContactUs/ContactUs";
import ShopRegisterForm from "./Components/User/Shop/ShopRegisterForm";
import DraggableList from "./Components/MainProduct/DraggableList";
import BulkPricePage from "./Components/Admin/BulkPrice/BulkPricePage";
import UserListPage from "./Components/User/Shop/UserListPage";
import ForgotPasswordPage from "./Components/User/UserLogin/ForgotPasswordPage";
import QuotationForm from "./Components/Admin/Quotation/QuotationForm";
import QuotationList from "./Components/Admin/Quotation/QuotationList";
import MainProductDraggableList from "./Components/MainProduct/MainProductDraggableList";
import QuotationListOne from "./Components/Admin/Quotation/QuotationListOne";
import OrderStepper from "./Components/User/Order/OrderProcess/OrderStepper";
import QuotationView from "./Components/Admin/Quotation/QuotationView/QuotationView";
import PrivacyTerms from "./Components/User/TC/PrivacyTerms";
import OrderList from "./Components/User/Order/OrderList/OrderList";
import OrderView from "./Components/User/Order/OrderList/OrderView";
import AboutUs from "./Components/User/AboutUs/AboutUs";
import EditOrder from "./Components/User/Order/EditOrder/EditOrder";
import PrivateRoute from "./Components/Layout/PrivateRoute";
import ClothMaster from "./Components/Admin/ClothMaster/ClothMaster";
import ClothType from "./Components/Admin/ClothType/ClothType";
import SublimationPriceTable from "./Components/Admin/BulkPrice/SublimationPriceTable";
import PrintAddons from "./Components/Admin/PrintAddons/PrintAddons";
import OrderTabsPage from "./Components/Admin/Quotation/OrderTabsPage";
import BannerUploadPage from "./Components/Admin/Banner/BannerUploadPage";
import SubProductDraggableList from "./Components/MainProduct/SubProductDraggableList";
import RefundReturnTerms from "./Components/User/TC/RefundReturnTerms";
import TrustedPartnersUpload from "./Components/Admin/Partners/TrustedPartnersUpload";
import CatalogueDownload from "./Components/CatalogueDownload/CatalogueDownload";
import ProductCataloguePDF from "./Components/CatalogueDownload/ProductCatalouge/ProductCataloguePDF";
import BulkPriceForm from "./Components/Admin/BulkPrice/BulkPriceForm/BulkPriceForm";
import CatgSubForm from "./Components/Category/CatgSubForm";
import CategoryList from "./Components/Category/CategoryList/CategoryList";
import SupplierPartyForm from "./Components/SupplierParty/SupplierPartyForm";
import SupplierPartyList from "./Components/SupplierParty/SupplierPartyList/SupplierPartyList";

function App() {
  return (
    <>
    <GlobalToast/>
    <Routes>
      
      {/* This is user layout routes */}
      <Route path="/" element={<RootLayout />}>
        <Route index element={<Home/>} />
        {/* <Route path="/subcategory/:mpid?/:mpname?" element={<UserSubCategoryPage/>}/> */}
        <Route path="/subcategory/:mpid?/:mpname?" element={<UserSubCategoryPageLoad/>}/>        
        {/* <Route path="/tbk/:subid?" element={<TbkProductPage/>}/> */}
        <Route path="/tbk/:subid?/:searchQuery?" element={<TbkProductPageScrollLoad/>}/>
        <Route path="/tbkDetail/:id?/:subid?" element={<TbkProductDetailPage/>}/>
        <Route path="/contact-us" element={<ContactUs/>}/>
        <Route path="/shop" element={<ShopRegisterForm/>}/>
        <Route path="/forgot-password" element={<ForgotPasswordPage/>}/>
        <Route path="/order-process/:id?" element={<PrivateRoute><OrderStepper/></PrivateRoute>}/>
        <Route path="/yours-order" element={<PrivateRoute><OrderList/></PrivateRoute>}/>        
        <Route path="/privacy-policy" element={<PrivacyTerms/>}/>
        <Route path="/refund-policy" element={<RefundReturnTerms/>}/>
        <Route path="/about-us" element={<AboutUs/>}/>
        <Route path="/catalogue-download" element={<CatalogueDownload/>}/>
        

        <Route path="/order-product/:id?" element={
          <PrivateRoute><EditOrder/></PrivateRoute>}/>
        </Route> 

      <Route path="/view-bill/:id?" element={<OrderView/>}/>
      <Route path="/productCatalogue-download/:data?" element={<ProductCataloguePDF/>}/>

      <Route path="/admin" element={<AppAdminLayout />}>
        <Route index element={<AdminLogin />}/>        
        <Route path="sublimation-cloth" element={<ClothMaster/>}/>
        <Route path="sublimation-print-type" element={<ClothType/>}/>
        <Route path="sublimation-print-addon" element={<PrintAddons/>}/>
        <Route path="sublimation-price" element={<SublimationPriceTable/>}/>
        <Route path="banner" element={<BannerUploadPage/>}/>
        <Route path="product" element={<AdminContent />}/>
        <Route path="main-sequence" element={<DraggableList/>}/>
        <Route path="main-product-sequence" element={<MainProductDraggableList/>}/>
        <Route path="sub-product-sequence" element={<SubProductDraggableList/>}/>
        <Route path="bulk-price" element={<BulkPriceForm/>}/>
        <Route path="bulk-price1" element={<BulkPricePage/>}/>
        <Route path="users" element={<UserListPage/>}/>
        <Route path="partners-logo" element={<TrustedPartnersUpload/>}/>

        {/* Ecommerce */}
        <Route path="catg-sub" element={<CatgSubForm/>}/>
        <Route path="catg-sub-list" element={<CategoryList/>}/>
        <Route path="sup" element={<SupplierPartyForm/>}/>
        <Route path="sup-list" element={<SupplierPartyList/>}/>
        
        {/* Nested quotation paths */}
        <Route path="quotation">
          <Route path="view/:id" element={<QuotationForm />} />
          <Route path="edit" element={<QuotationForm />} />
          <Route path="new" element={<QuotationForm />} />
        </Route>
        
        <Route path="quotation-list" element={<OrderTabsPage/>}/>
        
      </Route>      
    </Routes>
    </>
  );
}

export default App;
